export var E_ENABLED_STATUS;
(function (E_ENABLED_STATUS) {
    E_ENABLED_STATUS["ACTIVE"] = "active";
    E_ENABLED_STATUS["INACTIVE"] = "inactive";
})(E_ENABLED_STATUS || (E_ENABLED_STATUS = {}));
